import React from 'react';
import { Button, Checkbox, Stack, TableCell, TableRow, Typography } from '@mui/material';
import If from '@components/If';
import ModalityAvatar from '@components/ModalityAvatar';
import { StudyListItemModel } from '@core/types';
import { formatDate } from '@core/utils/formatDate';
import formatPatientAge from '@core/utils/formatPatientAge';
import useSx from './sx';

interface StudyRowProps {
  study: StudyListItemModel;
  onSelect: () => void;
  onDeselect: () => void;
  isSelected: boolean;
}

export default function StudyRow({ study, onSelect, onDeselect, isSelected }: StudyRowProps) {
  const excludeModalities = new Set(['DOC']);

  const sx = useSx();

  return (
    <TableRow sx={sx.tableRow}>
      <TableCell>
        <Checkbox
          checked={isSelected}
          onChange={() => (isSelected ? onDeselect() : onSelect())}
          inputProps={{ 'aria-label': 'Seleccionar estudio' }}
        />
      </TableCell>
      <TableCell>
        <ModalityAvatar modalities={study.modalities || ''} excludeModalities={excludeModalities} />
      </TableCell>
      <TableCell>
        <Stack className="PatientCellStack-root">
          <Typography className="EvoPatientCellLink-root" component="span">
            {`${study.patientsFullName?.trim()} ${formatPatientAge(study.patientsAge)}`}
          </Typography>
          <Typography className="EvoPatientCellDescription-root">
            {study.studyDescription?.toLowerCase()}
          </Typography>
        </Stack>
      </TableCell>
      {/* Nombre de paciente, fecha, descripcion del estudio en confirmacion*/}
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(study.studyDate || '')}</TableCell>
    </TableRow>
  );
}
